// @ts-check
import React from 'react';
import { Flex, Page, Stencil } from '../../pdf-design-system';
import { PagesProvider } from '../../pdf-design-system/Base/PageLayout/Page';
import UserLocaleProvider from '../../Providers/UserLocaleProvider';
import messages from '../California/locale/messages';
import ExampleContent from './ExampleContent';
// import preview from './previews/Avery8164ShippingLabels.png';

export default function Avery8164ShippingLabels({ locale = 'en', children }) {
  const labelItems = React.Children.toArray(children);
  const labelsPerPage = 6;
  return (
    <PagesProvider>
      <UserLocaleProvider locale={locale} messages={messages}>
        {Array.from(Array(Math.ceil(labelItems.length / labelsPerPage))).map(
          (_, index) => {
            const pageOfChildren = labelItems.slice(
              index * labelsPerPage,
              index * labelsPerPage + labelsPerPage
            );
            return (
              <LabelPageLayout key={index}>
                {/* <Stencil src={preview} style={{ height: '29.7cm' }} debug /> */}
                <LabelPage>{pageOfChildren}</LabelPage>
              </LabelPageLayout>
            );
          }
        )}
      </UserLocaleProvider>
    </PagesProvider>
  );
}

/** @param {{ children: React.ReactNode; style?: import('@react-pdf/types').Style; [x: string]: any }} props */
function LabelPageLayout({ children, style, ...rest }) {
  return (
    <Page
      size={{ width: '8.5in', height: '11in' }}
      style={[
        {
          paddingVertical: '0.45in',
          paddingHorizontal: '0.16in',
        },
        style,
      ]}
      theme={theme}
      {...rest}
    >
      {children}
    </Page>
  );
}

function LabelPage({ children }) {
  return (
    <Flex style={{ flexWrap: 'wrap', justifyContent: 'space-between' }}>
      {children}
    </Flex>
  );
}

export function LabelItem({ children }) {
  return (
    <Flex
      style={[
        {
          border: 1,
          borderColor: 'black',
          borderRadius: 12,
          height: '3.33in',
          width: '4in',
          justifyContent: 'center',
          alignItems: 'center',
        },
      ]}
    >
      {children}
    </Flex>
  );
}

/**
 * @typedef {import('../../pdf-design-system/useTheme').BottlebooksPDFTheme["theme"] & {
 *  colors?: Record<string, string>;
 * }} Theme
 */

/** @type {Theme} */
export const theme = {
  components: {
    Text: {
      default: { fontSize: 10, lineHeight: 7.8 / 6.5 },
    },
    Title: {
      default: {
        fontSize: 10,
        lineHeight: 1,
      },
    },
  },
};

export function Example() {
  const exampleData = [
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
    <ExampleContent />,
  ];
  return (
    <Avery8164ShippingLabels locale={'en'}>
      {exampleData.map((item, index) => (
        <LabelItem key={index}>{item}</LabelItem>
      ))}
    </Avery8164ShippingLabels>
  );
}
